import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CheckBoxSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CheckBoxSVG;
